import React from "react";
import {
  Video,
  ShieldAlert,
  Network,
  Antenna,
  Box,
} from "lucide-react";
import { IMG, SOLUTION_NODES } from "@/lib/content";

const iconMap = {
  video: Video,
  alarm: ShieldAlert,
  network: Network,
  mast: Antenna,
  box: Box,
};

export default function Solution() {
  return (
    <section
      id="loesung"
      data-testid="solution-section"
      className="relative bg-[#0B1220] text-white py-24 md:py-32 overflow-hidden"
    >
      <img
        src={IMG.network}
        alt="Abstraktes Netzwerk"
        className="absolute inset-0 h-full w-full object-cover opacity-20"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B1220]/80 via-[#0B1220]/70 to-[#0B1220]" />
      <div className="absolute inset-0 bg-grid-dark opacity-40" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <p className="tag-line text-xs font-mono-tech uppercase tracking-[0.25em] text-white/60 mb-6">
            Die Xortec Gesamtlösung
          </p>
          <h2
            data-testid="solution-headline"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white"
          >
            Alles aus einer Hand –{" "}
            <span className="text-[#5BA8FF]">
              vom Mast bis zur aktiven Netzwerktechnik.
            </span>
          </h2>
          <p className="mt-6 text-white/75 text-base sm:text-lg leading-relaxed">
            Wir liefern keine Einzelteile, sondern ein abgestimmtes System.
            Geplant, vormontiert und integriert für Ihren professionellen
            Sicherheitseinsatz.
          </p>
        </div>

        <div
          data-testid="solution-diagram"
          className="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4"
        >
          {SOLUTION_NODES.map((node, i) => {
            const Icon = iconMap[node.key] || Network;
            return (
              <div
                key={node.key}
                data-testid={`solution-node-${node.key}`}
                className="diagram-node rounded-xl p-6 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-center justify-between mb-5">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-[#0055A4]/20 border border-[#5BA8FF]/30 text-[#5BA8FF]">
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="font-mono-tech text-[10px] text-white/40 tracking-widest">
                    NODE.{String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="font-display font-medium text-base">
                  {node.label}
                </div>
                <div className="mt-1 text-white/60 text-xs leading-relaxed">
                  {node.desc}
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-12 line-fade-x" />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-sm text-white/70">
          <div>
            <div className="font-mono-tech text-[#5BA8FF] text-xs tracking-widest mb-2">
              01 · PLANUNG
            </div>
            Projektberatung, Konzeption und Auslegung Ihrer Infrastruktur.
          </div>
          <div>
            <div className="font-mono-tech text-[#5BA8FF] text-xs tracking-widest mb-2">
              02 · VORMONTAGE
            </div>
            Werkseitige Integration aller aktiven und passiven Komponenten.
          </div>
          <div>
            <div className="font-mono-tech text-[#5BA8FF] text-xs tracking-widest mb-2">
              03 · INTEGRATION
            </div>
            Saubere Anbindung an Ihre Sicherheits- und Netzwerklandschaft.
          </div>
        </div>
      </div>
    </section>
  );
}
